import { render, staticRenderFns } from "./LawStatisticDetails.vue?vue&type=template&id=88d05a9e&scoped=true&"
import script from "./LawStatisticDetails.vue?vue&type=script&lang=js&"
export * from "./LawStatisticDetails.vue?vue&type=script&lang=js&"
import style0 from "./LawStatisticDetails.vue?vue&type=style&index=0&id=88d05a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88d05a9e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBreadcrumbs,VBtn,VContainer,VList,VListItem,VMenu,VSelect})
